import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ClientBankAccountValidationService } from 'src/app/services/client-bank-account-validation.service';

@Component({
  selector: 'terra-iban-field',
  template: `
    <div class="terra-form-field-wrapper">
      <mat-icon color="primary" class="notranslate" matTooltipClass="terra-tooltip" matTooltipPosition="right" matTooltip="{{ tooltip }}">help</mat-icon>
      <label for="{{ inputId }}" class="text-input-label">IBAN</label>
      <mat-form-field appearance="outline">
        <input matInput id="{{ inputId }}" [placeholder]="placeholder" class="uppercase-input lo_sensitive" [formControl]="control" [required]="requiredField" />
        <mat-hint align="start">{{ hint }}</mat-hint>
        <mat-hint align="end"
          ><i
            class="fa fa-info-circle fa-lg"
            matTooltipClass="terra-tooltip"
            matTooltipPosition="right"
            matTooltip="{{ tooltip }}"
            matTooltipPosition="before"
            matTooltipClass="terra-tooltip"
          ></i
        ></mat-hint>
        <mat-error *ngIf="control.hasError('required')">Required</mat-error>
        <mat-error *ngIf="control.hasError('pattern')">Please insert an IBAN that matches the selected country</mat-error>
      </mat-form-field>
    </div>
  `
})
export class IbanFieldComponent implements OnInit {
  @Input()
  public requiredField: boolean;
  @Input()
  public inputId: string;
  @Input()
  public control: UntypedFormControl;
  @Input()
  public hint: string;
  @Input()
  public placeholder: string;
  @Input()
  public length: number;

  public tooltip: string;

  constructor(private validationService: ClientBankAccountValidationService) {}

  ngOnInit(): void {
    this.tooltip =
      'IBAN stands for International Bank Account Number. The International Bank Account Number (IBAN) is an international standard for identifying bank accounts across national borders. It contains both letters and numbers and should consist of ' +
      this.length +
      ' digits.';
    this.control.valueChanges
      .subscribe(val => {
        if (val !== null && val !== undefined && val.length > 0) {
          this.control.setErrors({ pattern: true });
          const validationResult = this.validationService.validateIBANField(val, this.length);
          if (validationResult !== null && validationResult !== undefined && (validationResult.patterns === null || validationResult.patterns === undefined)) {
            const validValue = this.control.value
              .replace(/ /g, '')
              .replace(/-/g, '')
              .toUpperCase();
            this.control.setValue(validValue, {emitEvent: false});
            this.control.setErrors({ pattern: true });
            this.control.updateValueAndValidity({emitEvent: false});
          }
        } else {
          this.control.updateValueAndValidity({emitEvent: false});
        }
      });
  }
}
